import type { VerificationItem } from "../data";

// ── Tone / status palette ─────────────────────────────────────────────────────

export const statusColors: Record<string, { bg: string; fg: string }> = {
  Active: { bg: "#e4f5ec", fg: "#166534" },
  Verified: { bg: "#e4f5ec", fg: "#166534" },
  Hired: { bg: "#e4f5ec", fg: "#166534" },
  Released: { bg: "#e4f5ec", fg: "#166534" },
  Sent: { bg: "#e4f5ec", fg: "#166534" },
  Resolved: { bg: "#e4f5ec", fg: "#166534" },
  Success: { bg: "#e4f5ec", fg: "#166534" },
  Completed: { bg: "#e4f5ec", fg: "#166534" },
  Pending: { bg: "#fef3c7", fg: "#92400e" },
  "Pending Review": { bg: "#fef3c7", fg: "#92400e" },
  "Under Review": { bg: "#fef3c7", fg: "#92400e" },
  Applied: { bg: "#fef3c7", fg: "#92400e" },
  Viewed: { bg: "#fef3c7", fg: "#92400e" },
  Shortlisted: { bg: "#fef3c7", fg: "#92400e" },
  Draft: { bg: "#fef3c7", fg: "#92400e" },
  Scheduled: { bg: "#dbeafe", fg: "#1e40af" },
  Escrow: { bg: "#dbeafe", fg: "#1e40af" },
  Expedited: { bg: "#dbeafe", fg: "#1e40af" },
  Suspended: { bg: "#fee2e2", fg: "#991b1b" },
  Rejected: { bg: "#fee2e2", fg: "#991b1b" },
  Archived: { bg: "#fee2e2", fg: "#991b1b" },
  Failed: { bg: "#fee2e2", fg: "#991b1b" },
  Refunded: { bg: "#fee2e2", fg: "#991b1b" },
  Open: { bg: "#fee2e2", fg: "#991b1b" },
  Cancelled: { bg: "#f3f4f6", fg: "#6b7280" },
  Withdrawn: { bg: "#f3f4f6", fg: "#6b7280" },
  Closed: { bg: "#f3f4f6", fg: "#6b7280" },
  Dismissed: { bg: "#f3f4f6", fg: "#6b7280" },
  Inactive: { bg: "#f3f4f6", fg: "#6b7280" },
  Unverified: { bg: "#f3f4f6", fg: "#6b7280" },
  Normal: { bg: "#f3f4f6", fg: "#6b7280" },
  // Automated verification check result (server/src/utils/autoVerification.ts)
  // — distinct from Verified/Unverified above, which is the final, possibly
  // manually-corrected outcome.
  "Auto-Verified": { bg: "#e4f5ec", fg: "#166534" },
  "Manual Review": { bg: "#fef3c7", fg: "#92400e" },
  "Check Failed": { bg: "#fee2e2", fg: "#991b1b" },
  "Pending Check": { bg: "#fef3c7", fg: "#92400e" },
  "No Check On Record": { bg: "#f3f4f6", fg: "#6b7280" },
};

/**
 * Human label for a talent/org's identity_check_state / kyb_check_state.
 * `null` covers two different things and this can't tell them apart from the
 * state alone: nothing was ever submitted, OR the account was verified before
 * this check existed. "No check on record" is honest either way — it never
 * claims a check ran when the column is simply empty.
 */
export function checkStateLabel(state: VerificationItem["checkState"] | undefined | null): string {
  switch (state) {
    case "auto_passed": return "Auto-Verified";
    case "manual_review": return "Manual Review";
    case "auto_failed": return "Check Failed";
    case "pending": return "Pending Check";
    default: return "No Check On Record";
  }
}
